import instance from '@/api/index.js'
const urlPrefix = '/v1/task'
export default {
  uploadTasks (body){
    return instance({
      method: 'post',
      url: `${urlPrefix}/upload`,
      data: body,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
  },
  addPlanToPms(data) {
    return instance({
      method: 'post',
      url: `${urlPrefix}/groups/plan`,
      data: data
    })
  },
  getTasks(params) {
    return instance({
      method: 'get',
      url: `${urlPrefix}/self/list`,
      params: params,
    })

  },
  getAllTasks(params) {
    return instance({
      method: 'get',
      url: `${urlPrefix}/list`,
      params: params,
    })

  },
  updateTask(params, data) {
    return instance({
      method: 'patch',
      url: `${urlPrefix}`,
      params: params,
      data: data
      }
    )
  },
  getTaskSummary(params) {
    return instance({
      method: 'get',
      url: `${urlPrefix}/summary`,
      params: params,
    })
  }






}
